import { Entity } from './Entity';

import type { CalendarEvent } from './CalendarEvent';


class Expense extends Entity {
    when: CalendarEvent;

    constructor(name: string, amount: number, when: CalendarEvent) {
        super(name, amount);
        this.when = when;
    }

    payout(startDate: Date, endDate: Date): number {
        const occurrancesInRange = this.when.occurances(startDate, endDate);
        return this.amount * occurrancesInRange;
    } 
};


export { Expense };